import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { Minute } from '@nu-art/ts-common';
export const ApiDef_AdvisorSession = {
    _v1: {
        validateAdvisorSession: { method: HttpMethod.GET, path: '/v1/advisor-session/validate', timeout: Minute },
    }
};
//# sourceMappingURL=api-def.js.map